module.exports = __webpack_public_path__ + "static/media/solution-decor1.f1916968.png";